import { ActionIcon } from '@mantine/core';
import { IconFile, IconX } from '@tabler/icons-react';

import styles from './UploadedFile.module.scss';
import { Props } from './UploadedFile.types';

const UploadedFile = ({ name, onDelete }: Props) => {
  return (
    <div className={styles.container}>
      <ActionIcon radius={'xl'} color={'#0e5b61'} className={styles.deleteFile} onClick={onDelete}>
        <IconX style={{ width: '70%', height: '70%' }} stroke={1.5} />
      </ActionIcon>
      <IconFile size={16} className={styles.icon} />
      <div className={styles.nameContainer}>
        <div className={styles.name}>{name}</div>
      </div>
    </div>
  );
};

export default UploadedFile;
